module.exports = __webpack_public_path__ + "img/1528383556.89505a15.jpg";